/**
 * The board — the landing pane of the workspace (spec #44 §1.2).
 *
 * Three lanes, side by side down to 900 px and stacked below it. Each one
 * owns its own loading, empty and error state, which is what lets a
 * half-landed backend still render a legible screen: a missing plan
 * endpoint darkens one column, not the workspace.
 */

import { EffectLane } from './EffectLane';
import { LiveWorkLane } from './LiveWorkLane';
import { QuestionsLane } from './QuestionsLane';
import styles from './workspace.module.css';

export function BoardPane() {
  return (
    <div className={styles.lanes} data-testid="board-pane">
      <QuestionsLane />
      <LiveWorkLane />
      <EffectLane />
    </div>
  );
}
